import axios from 'axios'
import {VueAxios} from './axios'
import {Toast} from 'vant'

let apiBaseUrl = window._CONFIG['domianURL'] || "/jeecg-boot";
console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
    // baseURL: '/', // api base_url
    baseURL: apiBaseUrl, // api base_url
    timeout: 15000 // 请求超时时间
})

const err = (error) => {
    if (error.response) {
        let data = error.response.data;
        switch (error.response.status) {
            case 403:
                Toast('拒绝访问');
                break;
            case 500:
                Toast(data.message);
                break;
            case 502:
                Toast('很抱歉，服务器正在维护');
                this.$router.go(0);
                break;
            case 404:
                Toast('很抱歉，资源未找到!');
                break;
            case 504:
                Toast('网络超时');
                break;
            case 401:
                Toast('未授权，请重新登录');
                setTimeout(() => {
                    this.$router.go(0);
                }, 1500)
                break
            default:
                Toast(data.message);
                break
        }
    }
    return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
    // const token = Vue.ls.get(ACCESS_TOKEN)
    // if (token) {
    //   config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    // }
    Toast.loading({
        message: '加载中...',
        forbidClick: true,
    })
    return config
}, (error) => {
    return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    Toast.clear()
    return response.data
}, err);

const installer = {
    vm: {},
    install(Vue, router = {}) {
        Vue.use(VueAxios, router, service)
    }
};

export {
    installer as VueAxios,
    service as axios
}
